// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ee4788ce","845":"12885fc3"}[chunkId] + ".chunk.js";
};